import styled from 'styled-components';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';

interface HighlightProps {
  text: string;
  searchText?: string;
}

const PreWhiteSpaceSpan = styled(P).attrs({ as: 'span' })`
  white-space: pre;
`;

const HighlightText = ({ text, searchText }: HighlightProps) => {
  if (!searchText) return <P as="span">{text}</P>;

  const regex = new RegExp(`(${searchText})`, 'gi');
  const matches = text.match(regex);

  if (!matches) return <P as="span">{text}</P>;

  const parts = text.split(regex);

  const elements = parts.map((part) => {
    if (searchText.toLowerCase() === part.toLowerCase())
      return (
        <PreWhiteSpaceSpan key={part} weight="extrabold">
          {part}
        </PreWhiteSpaceSpan>
      );

    return <PreWhiteSpaceSpan key={part}>{part}</PreWhiteSpaceSpan>;
  });

  return <Flex>{elements}</Flex>;
};

export default HighlightText;
